import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Card as BaseCard } from '@leroy-merlin-br/backyard-react'

import { Theme } from 'scripts/react-components/themes/Theme'

const cardStyles = ({ theme }: Theme) => css`
  label: products--card;

  margin-bottom: ${theme.spacings.giga};

  @media (max-width: ${theme.breakpoints.kilo}rem) {
    & > div {
      padding: 0 ${theme.spacings.byte};
    }
  }
`

const spacingWrapperStyles = ({ theme }: Theme) => css`
  label: products--spacing-wrapper;

  margin-bottom: ${theme.spacings.mega};
`

const productListStyles = ({ theme }: Theme) => css`
  label: products--product-list;

  display: grid;
  grid-gap: ${theme.spacings.byte};
  grid-template-columns: repeat(2, 1fr);
  justify-items: center;

  ${theme.media.mega} {
    grid-template-columns: repeat(3, 1fr);
    grid-gap: ${theme.spacings.mega};
  }

  ${theme.media.giga} {
    grid-template-columns: repeat(4, 1fr);
    grid-gap: ${theme.spacings.mega};
  }
`

const paginationWrapper = ({ theme }: Theme) => css`
  label: products--pagination;

  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: ${theme.spacings.mega};
`

export const Card = styled(BaseCard)(cardStyles)
export const SpacingWrapper = styled('div')(spacingWrapperStyles)
export const ProductList = styled('div')(productListStyles)
export const PaginationWrapper = styled('div')(paginationWrapper)
